import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ContentLoading } from '../components/ui/ContentLoading';
import { lazyRetry } from '../util/codeSplitting';
import { commonRoutes } from './constants';
import { PrivateRoute } from './routes/PrivateRoute';
import { PublicRedirectRoute } from './routes/PublicRedirectRoute/PublicRedirectRoute';

const ResetPasswordPage = React.lazy(() => lazyRetry(() => import('../pages/reset-password'), 'resetPassword'));
const Registration = React.lazy(() => lazyRetry(() => import('../pages/Registration'), 'registration'));
const RegistrationStudioPage = React.lazy(() =>
    lazyRetry(() => import('../pages/registration-studio'), 'registrationStudio'),
);
const RegistrationUserPage = React.lazy(() =>
    lazyRetry(() => import('../pages/registration-user'), 'registrationUser'),
);
const LoginPage = React.lazy(() => lazyRetry(() => import('../pages/login'), 'login'));
const PublicReservationByReservationTokenPage = React.lazy(() =>
    lazyRetry(
        () => import('../pages/reservation/PublicReservationByReservationTokenPage'),
        'publicReservationByReservationTokenPage',
    ),
);
const PublicEvent = React.lazy(() => lazyRetry(() => import('../pages/PublicEvent'), 'publicEvent'));

const WaitlistNotification = React.lazy(() =>
    lazyRetry(() => import('../pages/WaitlistNotification'), 'waitlistNotification'),
);
const RegistrationConfirmation = React.lazy(() =>
    lazyRetry(() => import('../pages/registration-confirmation/RegistrationConfirmation'), 'registrationConfirmation'),
);
const ResetPasswordConfirmationPage = React.lazy(() =>
    lazyRetry(() => import('../pages/reset-password-confirmation'), 'resetPasswordConfirmation'),
);
const Styleguide = React.lazy(() => lazyRetry(() => import('../pages/styleguide'), 'styleguide'));
const PublicPagesRouter = React.lazy(() => lazyRetry(() => import('./PublicPagesRouter'), 'publicPagesRouter'));
const Dashboard = React.lazy(() => lazyRetry(() => import('../pages/dashboard/Dashboard'), 'dashboard'));

const CommonRoutesSwitch = () => {
    return (
        <React.Suspense fallback={<ContentLoading />}>
            <Switch>
                <PublicRedirectRoute path={`/${commonRoutes.RESET_PASSWORD}`}>
                    <ResetPasswordPage />
                </PublicRedirectRoute>
                <PublicRedirectRoute
                    path={[`/${commonRoutes.REGISTRATION}`, `${commonRoutes.REGISTRATION}?fromDomain=:fromDomain`]}
                >
                    <Registration />
                </PublicRedirectRoute>
                <PublicRedirectRoute path={`/${commonRoutes.REGISTRATION_STUDIO}`}>
                    <RegistrationStudioPage />
                </PublicRedirectRoute>
                <PublicRedirectRoute
                    path={[
                        `/${commonRoutes.REGISTRATION_USER}`,
                        `${commonRoutes.REGISTRATION_USER}?fromDomain=:fromDomain`,
                    ]}
                >
                    <RegistrationUserPage />
                </PublicRedirectRoute>
                <PublicRedirectRoute
                    path={[`/${commonRoutes.LOGIN}`, `${commonRoutes.LOGIN}?fromLocation=:fromLocation`]}
                >
                    <LoginPage />
                </PublicRedirectRoute>
                <Route
                    path={[
                        `/reservation/:reservationToken`,
                        `/${commonRoutes.EVENTS}/:lectureInstanceTermGraphQlId/reservation/:reservationToken`,
                    ]}
                >
                    <PublicReservationByReservationTokenPage />
                </Route>
                <Route path={`/${commonRoutes.EVENTS}/:lectureInstanceTermGraphQlId`}>
                    <PublicEvent />
                </Route>
                <Route path={`/${commonRoutes.WAITLIST_NOTIFICATION}/:waitlistNotificationGraphQlId`}>
                    <WaitlistNotification />
                </Route>
                <Route path={`/${commonRoutes.ORGANISATION}/confirmation/:confirmationToken/:email/:domain`}>
                    <RegistrationConfirmation type="organisation" />
                </Route>
                <Route path={`/${commonRoutes.USER}/confirmation/:confirmationToken/:email`}>
                    <RegistrationConfirmation type="user" />
                </Route>
                <Route path={`/${commonRoutes.RESET_PASSWORD_CONFIRMATION}/:confirmationToken/:email`}>
                    <ResetPasswordConfirmationPage />
                </Route>
                {/* FIXME_NOT_MVP add to commonRoutes to codebook */}
                <Route path="/styleguide">
                    <Styleguide />
                </Route>
                <Route path="/:studioDomain">
                    <PublicPagesRouter />
                </Route>
                <PrivateRoute path="/">
                    <Dashboard />
                </PrivateRoute>
            </Switch>
        </React.Suspense>
    );
};

export default CommonRoutesSwitch;
